import styled from 'styled-components';

import { minWidth } from '../../utils/mediaQueries';
import { CustomizableInput } from '../FormInput';
import { Input as StyledInput } from '../FormInput/styles';

export const StyledTextArea = styled(StyledInput).attrs({ as: 'textarea' })<{
	$resizable: boolean;
}>`
	min-height: 3em;
	min-width: 100%;
	padding-top: ${p => (p.$provideSpaceForAnimatedLabel ? '21px' : '12px')};
	padding-bottom: ${p => (p.$provideSpaceForAnimatedLabel ? '0' : '7px')};
	${minWidth('mobileLarge')} {
		min-height: ${28 / 9}em;
		padding-top: ${p => (p.$provideSpaceForAnimatedLabel ? '24px' : '14px')};
		padding-bottom: ${p => (p.$provideSpaceForAnimatedLabel ? '0' : '9px')};
	}
	${p => (p.$resizable ? '' : 'resize: none')}
`;

export const Wrapper = styled(CustomizableInput).attrs({
	CustomInput: StyledTextArea,
})``;
